import { Box, Stack } from "@mantine/core";
import React from "react";
import ConnectedArcgisProject from "./ConnectedArcgisProject";

const ArcGisSettingsPage = () => {
  return (
    <Box h="100%" mah="calc(100vh - 150px)" style={{ overflowY: "auto", minHeight: 0 }}>
      <Stack gap="md" pr="sm" pb="lg">
        <ConnectedArcgisProject />
      </Stack>
    </Box>
  );
};

export default ArcGisSettingsPage;
